import { render, staticRenderFns } from "./ContainerMovement.vue?vue&type=template&id=0d45acb0&scoped=true"
import script from "./ContainerMovement.vue?vue&type=script&lang=js"
export * from "./ContainerMovement.vue?vue&type=script&lang=js"
import style0 from "./ContainerMovement.vue?vue&type=style&index=0&id=0d45acb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d45acb0",
  null
  
)

export default component.exports